<template>
  <BaseAction>
    <PrimaryButton
      :loading="updating"
      @click.native="openDialog"
      light
      shrink
      v-if="isApprove"
    >
      {{ status }}
      <v-icon class="ml-2">{{ icon }}</v-icon>
    </PrimaryButton>
    <ErrorButton
      :loading="updating"
      @click.native="openDialog"
      light
      shrink
      v-else
    >
      {{ status }}
      <v-icon class="ml-2">{{ icon }}</v-icon>
    </ErrorButton>
    <ConfirmationDialog
      :title="title"
      :buttonText="buttonText"
      :isOpen="isOpen"
      :isLoading="updating"
      :isError="!isApprove"
      @close="closeDialog"
      @submit="handleSubmit"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseAction from "@/components/common/BaseAction";
import ConfirmationDialog from "@/components/common/ConfirmationDialog";
import ErrorButton from "@/components/common/Button/ErrorButton";

export default {
  props: {
    referenceId: String,
    updating: Boolean,
    isApprove: Boolean
  },
  components: {
    BaseAction,
    PrimaryButton,
    ConfirmationDialog,
    ErrorButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    status() {
      return this.isApprove ? "Approve" : "Reject";
    },
    title() {
      return `Are you sure you want to ${this.status.toLowerCase()} reference?`;
    },
    buttonText() {
      return `${this.status} Reference`;
    },
    icon() {
      return this.isApprove ? "mdi-check" : "mdi-close";
    }
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.isApprove);
      this.closeDialog();
    },
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
